import { resetWhenRouterChange } from '@ui/utils/zustandMiddleware';
import { create } from 'zustand';

export type UseDateRangePickerModalStore = {
  isOpen: boolean;
  selectedDate: Date[];
  dateForInitialView: Date | undefined;
  onConfirm: (selectedDate: Date[]) => void;
  onOpen: (options: {
    selectedDate: Date[];
    onConfirm: (selectedDate: Date[]) => void;
  }) => void;
  onClose: () => void;
};

export const useDateRangePickerModal = create(
  resetWhenRouterChange<UseDateRangePickerModalStore>((set) => ({
    isOpen: false,
    selectedDate: [],
    dateForInitialView: new Date(),
    onConfirm: () => {},
    onOpen: ({ onConfirm, selectedDate }) => {
      set({
        isOpen: true,
        selectedDate,

        onConfirm: onConfirm,
        /**
         * when this modal open, switch datePicker's view to this date
         */
        dateForInitialView: selectedDate[0] || new Date(),
      });
    },
    onClose: () => {
      useDateRangePickerModal.getState().$$resetData?.();
    },
  })),
);
